<template>
  <div v-if="placementExists">
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <h6 class="header-pretitle">Placement {{ placement.number }}</h6>
          <h1 class="header-title">End of Placement Review {{ title }}</h1>
        </div><!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">
      <div v-if="showProgressBar" class="row">
        <div class="col d-flex align-items-center">
          <div class="progress w-100">
            <div
              class="progress-bar"
              role="progressbar"
              :style="`width: ${progress}%`"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div><!-- /.progress -->
        </div>
        <div class="col-auto">
          <p class="progress-due-date">
            <strong>Due:</strong> {{ placement.end_component_due_date | date }}
          </p>
        </div>
      </div><!-- /.row -->

      <div v-if="showProgressBar" class="decorative-divider"></div>

      <router-view/>
    </div>
  </div>
</template>

<script>
import { placementMethods, placementComputed, graduateComputed, graduateMethods } from 'vx/helpers'

export default {
  props: {
    placementId: {
      required: true,
      type: Number
    },
    graduateId: {
      required: false,
      type: Number
    }
  },

  computed: {
    ...placementComputed,
    ...graduateComputed,

    progress () {
      return (this.$route.meta.progress || 0) * 100
    },

    showProgressBar () {
      return this.$route.meta.progress !== false
    },

    title () {
      if (this.$route.meta.title) {
        return `- ${this.$route.meta.title}`
      }

      return ''
    }
  },

  async created () {
    await Promise.all([
      this.getGraduate(this.graduateId || this.$user.id),
      this.getPlacement({
        graduate: this.graduateId || this.$user.id,
        placement: this.placementId
      })
    ])

    if (this.$userIsManager && this.$user.id !== this.placement.manager_id) {
      this.$noty.error('You are not the assigned manager for this placement.')

      this.$router.push({ name: 'graduates.placements.single' })
    }
  },

  beforeDestroy () {
    this.resetPlacement()
  },

  methods: {
    ...placementMethods,
    ...graduateMethods
  }
}
</script>
